import { create } from 'zustand';
import { api } from './api';

interface User {
  id: string;
  email: string;
  role: 'student' | 'researcher' | 'ambassador' | 'admin';
  first_name: string;
  last_name: string;
  avatar_url: string | null;
  email_verified: boolean;
  reliability_score: number;
  total_completed: number;
  total_no_shows: number;
  total_cancellations: number;
  is_active: boolean;
  onboarding_completed: boolean;
  campus_id: string;
  student_profile?: any;
  researcher_profile?: any;
}

interface AuthState {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (data: { email: string; password: string; first_name: string; last_name: string; role: string; invite_code?: string }) => Promise<void>;
  logout: () => Promise<void>;
  fetchUser: () => Promise<void>;
  setUser: (user: User) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  isAuthenticated: false,

  login: async (email, password) => {
    const result = await api.login({ email, password });
    localStorage.setItem('access_token', result.access_token);
    localStorage.setItem('refresh_token', result.refresh_token);
    set({ user: result.user, isAuthenticated: true, isLoading: false });
  },

  register: async (data) => {
    const result = await api.register(data);
    localStorage.setItem('access_token', result.access_token);
    localStorage.setItem('refresh_token', result.refresh_token);
    set({ user: result.user, isAuthenticated: true, isLoading: false });
  },

  logout: async () => {
    try {
      await api.logout();
    } catch {
      // ignore
    }
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    set({ user: null, isAuthenticated: false, isLoading: false });
  },

  fetchUser: async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      set({ user: null, isAuthenticated: false, isLoading: false });
      return;
    }
    try {
      const user = await api.getMe();
      set({ user, isAuthenticated: true, isLoading: false });
    } catch {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      set({ user: null, isAuthenticated: false, isLoading: false });
    }
  },

  setUser: (user) => set({ user }),
}));
